import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // 🟢 Tambahkan ini
import { User, Lock, FileText, HelpCircle, LogOut } from "react-feather";
import "../styles/Dashboard.css";

const ProfileDropdown = ({ username, userId }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate(); // 🟢 Gunakan `useNavigate`

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleLogout = () => {
        console.log("User logged out.");
        localStorage.removeItem("username"); // 🟢 Hapus username dari localStorage
        navigate("/login"); // 🟢 Arahkan ke halaman login
    };

    return (
        <div className="nav-icon-container">
            <button className="nav-icon-btn" onClick={toggleDropdown}>
                <User />
            </button>

            {isOpen && (
                <div className="dropdown-menu profile-dropdown">
                    
                    <div className="profile-header">
                        <p>{username}</p>
                        <span>{userId}</span>
                    </div>
                    <div className="profile-item"><Lock /> Change Password</div>
                    <div className="profile-item"><FileText /> Privacy Policy</div>
                    <div className="profile-item"><HelpCircle /> Help & Support</div>
                    <div className="profile-item logout" onClick={handleLogout}>
                        <LogOut /> Logout
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileDropdown;
